(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-map/assets/javascripts/map-play.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-map/assets/javascripts/map-play.js');

'use strict';

var _svs;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const cdn = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.core) === null || _svs === void 0 || (_svs = _svs.config) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.svsconfig) === null || _svs === void 0 ? void 0 : _svs.cdn2.replace('/content', '');
const {
  CONSTANTS
} = svs.lyckoplatsen.components.shared_constants;
const {
  getDefaultLocationName
} = svs.tur.lyckoplatsen.utils;
const {
  scrambleCoordinates
} = svs.tur.lyckoplatsen.map;
const defaultStore = jotai.getDefaultStore();
const {
  locationNameAtom
} = svs.lyckoplatsen.shared_map.atoms;
const {
  swe,
  mapDefaults,
  createMap,
  isPointInsideSweden,
  sweRectangleBounds,
  getIconLeaflet,
  disableInteraction,
  enableInteraction
} = svs.tur.lyckoplatsen.map;
const {
  fetchLocationName
} = svs.lyckoplatsen.shared_map.utils;
const {
  logger
} = svs.lyckoplatsen;
function getPlayMapHandler() {
  let map;
  let eventHandlers = {};
  let nodeId;
  let mapActionInProgress = false;
  let disableMapInteraction = false;
  let sweRec;
  let pin;
  let options;
  let initCenterZoom;
  let initCenterCoords;
  let minZoom;
  let maxZoom;
  const isNativeApp = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isNativeApp', window) && svs.core.config.data.svsconfig.isNativeApp;
  const isAndroid = svs.core.detect.os.android();
  return {
    createMap(mapOptions) {
      var _eventHandlers, _mapOptions$location;
      let evtHandlers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      options = _objectSpread(_objectSpread({}, mapDefaults), mapOptions);
      map = createMap(options, () => eventHandlers.showMapErrorDialog());
      minZoom = mapOptions.minZoom;
      maxZoom = mapOptions.maxZoom;
      nodeId = mapOptions.nodeId;
      Object.assign(eventHandlers, evtHandlers);
      sweRec = leaflet.rectangle(sweRectangleBounds, {
        color: 'yellow',
        fillOpacity: 0,
        weight: 1
      });
      map.fitBounds(sweRec.getBounds(), {
        paddingTopLeft: [10, 105],
        paddingBottomRight: [10, svs.core.detect.breakpoint.lessThan('sm') ? 0 : 85],
        animate: false,
        minZoom,
        maxZoom
      });
      initCenterCoords = map.getCenter();
      initCenterZoom = map.getZoom();
      (_eventHandlers = eventHandlers) === null || _eventHandlers === void 0 || _eventHandlers.updateZoomLevel(map.getZoom());
      map.on('click', e => this.handleMapClickAndKeyPress(e));
      map.on('keydown', e => this.handleMapClickAndKeyPress(e));
      this.handleZoomButtonsEvents();
      this.handleMapActionEvents();
      eventHandlers.disableCenterMapButton(true);
      if ((_mapOptions$location = mapOptions.location) !== null && _mapOptions$location !== void 0 && _mapOptions$location.lat) {
        map.setView(mapOptions.location, options.maxZoom, {
          animate: false
        });
      }
      return map;
    },
    handleZoomButtonsEvents() {
      map.whenReady(() => {
        const zoomInButton = document.querySelector('.leaflet-control-zoom-in');
        const zoomOutButton = document.querySelector('.leaflet-control-zoom-out');
        if (zoomInButton) {
          zoomInButton.addEventListener('click', () => {
            if (pin) {
              const zoomLevel = map.getZoom();
              map.setView(pin._latlng, zoomLevel + 1, {
                animate: false
              });
            }
          });
        }
        if (zoomOutButton) {
          zoomOutButton.addEventListener('click', () => {
            if (pin) {
              const zoomLevel = map.getZoom();
              map.setView(pin._latlng, zoomLevel - 1, {
                animate: false
              });
            }
          });
        }
      });
    },
    handleMapClickAndKeyPress(e) {
      var _e$originalEvent, _e$latlng, _e$latlng2;
      if (mapActionInProgress || (_e$originalEvent = e.originalEvent) !== null && _e$originalEvent !== void 0 && (_e$originalEvent = _e$originalEvent.target) !== null && _e$originalEvent !== void 0 && _e$originalEvent.closest('.leaflet-control')) {
        return;
      }
      let location;
      switch (e.type) {
        case 'click':
          location = {
            lat: Number((_e$latlng = e.latlng) === null || _e$latlng === void 0 ? void 0 : _e$latlng.lat.toFixed(6)),
            lng: Number((_e$latlng2 = e.latlng) === null || _e$latlng2 === void 0 ? void 0 : _e$latlng2.lng.toFixed(6))
          };
          break;
        case 'keydown':
          if (e.originalEvent.key === 'Enter') {
            var _map;
            const center = (_map = map) === null || _map === void 0 ? void 0 : _map.getCenter();
            location = {
              lat: scrambleCoordinates(Number(center === null || center === void 0 ? void 0 : center.lat.toFixed(6))),
              lng: scrambleCoordinates(Number(center === null || center === void 0 ? void 0 : center.lng.toFixed(6)))
            };
          } else if (e.originalEvent.key === 'Escape') {
            var _eventHandlers2, _eventHandlers2$mapCl;
            (_eventHandlers2 = eventHandlers) === null || _eventHandlers2 === void 0 || (_eventHandlers2$mapCl = _eventHandlers2.mapClicked) === null || _eventHandlers2$mapCl === void 0 || _eventHandlers2$mapCl.call(_eventHandlers2);
            this.removePin();
          }
          break;
        default:
      }
      if (!location) {
        return;
      }
      const inTerritory = isPointInsideSweden([location.lat, location.lng], swe.features[0].geometry.coordinates);
      if (inTerritory) {
        if (pin) {
          var _eventHandlers3, _eventHandlers3$mapCl;
          (_eventHandlers3 = eventHandlers) === null || _eventHandlers3 === void 0 || (_eventHandlers3$mapCl = _eventHandlers3.mapClicked) === null || _eventHandlers3$mapCl === void 0 || _eventHandlers3$mapCl.call(_eventHandlers3);
          this.removePin();
        } else {
          var _eventHandlers4, _eventHandlers4$mapCl;
          (_eventHandlers4 = eventHandlers) === null || _eventHandlers4 === void 0 || (_eventHandlers4$mapCl = _eventHandlers4.mapClicked) === null || _eventHandlers4$mapCl === void 0 || _eventHandlers4$mapCl.call(_eventHandlers4, location);
        }
      } else {
        if (pin) {
          this.removePin();
        }
        this.placeErrorCircle(location);
      }
    },
    handleMapActionEvents() {
      const mapEl = document.getElementById('mapPlay');
      const handleStart = () => {
        var _eventHandlers5, _eventHandlers5$updat;
        eventHandlers.disableCenterMapButton(false);
        (_eventHandlers5 = eventHandlers) === null || _eventHandlers5 === void 0 || (_eventHandlers5$updat = _eventHandlers5.updateIsMoving) === null || _eventHandlers5$updat === void 0 || _eventHandlers5$updat.call(_eventHandlers5, true);
        mapActionInProgress = true;
        disableMapInteraction && disableInteraction(map);
        if (mapEl && mapEl.classList.contains('svs-keyboard-focus')) {
          mapEl.blur();
        }
      };
      const handleEnd = () => {
        var _eventHandlers6, _eventHandlers6$updat, _eventHandlers7;
        (_eventHandlers6 = eventHandlers) === null || _eventHandlers6 === void 0 || (_eventHandlers6$updat = _eventHandlers6.updateIsMoving) === null || _eventHandlers6$updat === void 0 || _eventHandlers6$updat.call(_eventHandlers6, false);
        if (!pin) {
          this.mapEnabled();
        }
        mapActionInProgress = false;
        (_eventHandlers7 = eventHandlers) === null || _eventHandlers7 === void 0 || _eventHandlers7.updateZoomLevel(map.getZoom());
        if (mapEl && mapEl.classList.contains('svs-keyboard-focus')) {
          mapEl.focus();
        }
      };
      map.on('movestart', handleStart);
      map.on('zoomstart', handleStart);
      map.on('zoomend', handleEnd);
      map.on('moveend', handleEnd);
    },
    mapDisable() {
      disableMapInteraction = true;
      disableMapInteraction && disableInteraction(map);
    },
    mapEnabled() {
      disableMapInteraction && enableInteraction(map);
      disableMapInteraction = false;
    },
    removeMap() {
      if (pin) {
        try {
          if (pin && pin.isPopupOpen && pin.isPopupOpen()) {
            pin.closePopup();
          }
        } catch (err) {
        }
        try {
          if (pin && pin.remove) {
            pin.remove();
          }
        } catch (err) {
        }
        pin = null;
      }

      if (map) {
        try {
          if (typeof map.closePopup === 'function') {
            const hasPopup = map._popup;
            if (hasPopup && typeof hasPopup.close === 'function') {
              map.closePopup();
            }
          }
        } catch (err) {
        }
        try {
          if (typeof map.closeTooltip === 'function') {
            const hasTooltip = map._tooltip;
            if (hasTooltip && typeof hasTooltip.close === 'function') {
              map.closeTooltip();
            }
          }
        } catch (err) {
        }
      }

      if (sweRec) {
        try {
          if (sweRec && sweRec.remove) {
            sweRec.remove();
          }
        } catch (err) {
        }
        sweRec = null;
      }

      if (map) {
        try {
          map.off('movestart');
          map.off('zoomstart');
          map.off('zoomend');
          map.off('moveend');
          map.off();
          map.remove();
        } catch (err) {
        }
        map = null;
      }

      eventHandlers = {};
      options = null;
    },
    focusMap() {
      const mapEl = document.getElementById('mapPlay');
      mapEl.blur(); 
      mapEl.focus();
    },
    addEventHandlers(handlers) {
      Object.entries(handlers).forEach(_ref => {
        let [key, handler] = _ref;
        eventHandlers[key] = handler;
      });
    },
    moveTo(location) {
      var _location$zoomLevel;
      disableMapInteraction = true;
      const zoomLevel = (_location$zoomLevel = location.zoomLevel) !== null && _location$zoomLevel !== void 0 ? _location$zoomLevel : CONSTANTS.PLACE_PIN_ZOOM_LEVEL;
      const executeFlyTo = () => map.flyTo(location, zoomLevel);
      if (isNativeApp && isAndroid) {
        setTimeout(executeFlyTo, 300);
      } else {
        executeFlyTo();
      }
      map.once('moveend', () => {
        this.focusMap();
        disableMapInteraction = false;
      });
    },
    centerMap() {
      var _map2;
      map.once('moveend', () => {
        eventHandlers.disableCenterMapButton(true);
      });
      (_map2 = map) === null || _map2 === void 0 || _map2.setView(initCenterCoords, initCenterZoom, {
        animate: false
      });
    },

    pinHide(tl) {
      tl.set(".pin-heart svg", {
        opacity: 0,
        height: '0px'
      });
    },
    pinAnimate(tl) {
      var _eventHandlers$showPi, _eventHandlers8;
      this.mapDisable();
      (_eventHandlers$showPi = (_eventHandlers8 = eventHandlers).showPin) === null || _eventHandlers$showPi === void 0 || _eventHandlers$showPi.call(_eventHandlers8, true);
      tl.to("#".concat(nodeId, " .pin-heart svg"), {
        opacity: 1,
        height: '80px',
        duration: 1.2,
        ease: 'elastic(1, 0.5)'
      });
      tl.to("#".concat(nodeId, " .pin-heart svg"), {
        width: '54px',
        duration: 0.9,
        ease: 'back.out(1.2)'
      }, '<');
    },
    pinAdd(pin) {
      pin.addTo(map);
    },
    pinFlyTo(map, target, maxZoom) {
      let animate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      disableMapInteraction = true;
      map.once('moveend', () => {
        disableMapInteraction = false;
      });
      map.flyTo(target, maxZoom, {
        animate
      });
    },
    async addPopup(location, charity, locationType) {
      let locationName = getDefaultLocationName();
      const isHomeLocation = locationType === CONSTANTS.LOCATION_TYPES.HOME;
      if (isHomeLocation) {
        var _svs$lyckoplatsen$dat, _svs$lyckoplatsen$dat2;
        const {
          street,
          town
        } = (_svs$lyckoplatsen$dat = (_svs$lyckoplatsen$dat2 = svs.lyckoplatsen.data.homeLocation) === null || _svs$lyckoplatsen$dat2 === void 0 ? void 0 : _svs$lyckoplatsen$dat2.playerAddress) !== null && _svs$lyckoplatsen$dat !== void 0 ? _svs$lyckoplatsen$dat : {};
        if (street && town) {
          locationName = "".concat(street, ", ").concat(town);
        }
      } else {
        try {
          var _locationName$county, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _locationName$pointOf;
          locationName = await fetchLocationName(location);
          const locationCounty = (_locationName$county = locationName.county) !== null && _locationName$county !== void 0 ? _locationName$county : location.region;
          locationName = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_ref6 = (_ref7 = (_ref8 = (_locationName$pointOf = locationName.pointOfInterest) !== null && _locationName$pointOf !== void 0 ? _locationName$pointOf : locationName.neighbourhood) !== null && _ref8 !== void 0 ? _ref8 : locationName.natureReserve) !== null && _ref7 !== void 0 ? _ref7 : locationName.naturePark) !== null && _ref6 !== void 0 ? _ref6 : locationName.locality) !== null && _ref5 !== void 0 ? _ref5 : locationName.localAdmin) !== null && _ref4 !== void 0 ? _ref4 : locationName.county) !== null && _ref3 !== void 0 ? _ref3 : locationName.region) !== null && _ref2 !== void 0 ? _ref2 : getDefaultLocationName();
          if (locationCounty && locationCounty !== locationName) {
            locationName += ", ".concat(locationCounty);
          }
          defaultStore.set(locationNameAtom, locationName);
        } catch (error) {
          eventHandlers.showDialogLocationError();
          logger.warn('Failed to fetch location name', error);
        }
      }

      let content = "<p class=\"leaflet-popup-header ".concat(isHomeLocation ? 'data-hj-suppress' : '', "\"><span class=\"bold f-600\">").concat(locationName, "</span><br/>").concat(location.lat, "&deg;N &nbsp; ").concat(location.lng, "&deg;E</p>");
      if (charity) {
        content += "<img class=\"margin-top-1\" width=\"100\" src=".concat(cdn + charity.logotypeId, " alt=").concat(charity.name, " />");
      }
      const popup = leaflet.popup({
        minWidth: 250,
        maxWidth: 400
      }).setLatLng(location).setContent(content).openOn(map);
      popup._closeButton.addEventListener('click', () => {
        var _eventHandlers9, _eventHandlers9$mapCl;
        (_eventHandlers9 = eventHandlers) === null || _eventHandlers9 === void 0 || (_eventHandlers9$mapCl = _eventHandlers9.mapClicked) === null || _eventHandlers9$mapCl === void 0 || _eventHandlers9$mapCl.call(_eventHandlers9);
        this.removePin();
      });
    },
    placePin(_ref9) {
      let {
        location,
        animateFlyTo
      } = _ref9;
      const icon = getIconLeaflet({
        color: 'red'
      });
      pin = leaflet.marker(location, {
        icon
      });
      const tl = gsap.timeline();
      disableMapInteraction = true;
      map.once('moveend', () => {
        disableMapInteraction = false;
        this.pinAdd(pin);
        this.pinHide(tl);
        this.pinAnimate(tl);
      });
      map.flyTo(location, options.maxZoom, {
        animate: animateFlyTo
      });
      return pin;
    },
    removeCircle(circle) {
      circle.remove();
    },
    removePin() {
      var _eventHandlers$showPi2, _eventHandlers0;
      if (pin) {
        this.mapEnabled();
        try {
          if (pin && pin.isPopupOpen && pin.isPopupOpen()) {
            pin.closePopup();
          }
        } catch (err) {
        }
        try {
          if (pin && pin.remove) {
            pin.remove();
          }
        } catch (err) {
        }
        pin = null;
      }

      if (map) {
        try {
          if (typeof map.closePopup === 'function') {
            const hasPopup = map._popup;
            if (hasPopup && typeof hasPopup.close === 'function') {
              map.closePopup();
            }
          }
        } catch (err) {
        }
      }
      (_eventHandlers$showPi2 = (_eventHandlers0 = eventHandlers).showPin) === null || _eventHandlers$showPi2 === void 0 || _eventHandlers$showPi2.call(_eventHandlers0, false);
      this.focusMap();
    },
    circleAnimate(tl) {
      tl.set(".cirlce-error", {
        opacity: 0,
        scale: 0,
        transformOrigin: '50% 50%'
      });
      tl.to(".cirlce-error", {
        scale: 1,
        duration: 0.4,
        ease: 'back.out(1.2)'
      }, '<');
      tl.to(".cirlce-error", {
        opacity: 0.5,
        duration: 0.25
      }, '<');
      tl.to(".cirlce-error", {
        opacity: 0,
        duration: 0.15,
        delay: 0.25
      }, '<');
    },
    placeErrorCircle(location) {
      const circle = leaflet.circleMarker(location, {
        color: 'red',
        radius: 20,
        weight: 0,
        fillOpacity: 1,
        className: 'cirlce-error'
      });
      circle.addTo(map);
      const tl = gsap.timeline({
        onComplete: () => this.removeCircle(circle)
      });
      this.circleAnimate(tl);
      return circle;
    }
  };
}
Object.assign(svs.lyckoplatsen.components.shared_map, {
  getPlayMapHandler
});

 })(window);